import { useState } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useTranslation } from "react-i18next";
import { css } from "../../../../../styled-system/css";
import { HStack, VStack } from "../../../../../styled-system/jsx";
import { Modal } from "../../../../components/core/basic/Modal";
import { Button } from "../../../../components/core/basic/Button";
import { useBulkUpdateDayparting } from "../../api/useBulkUpdateDayparting";
import { DayPartingForm } from "./DayPartingForm";
import type { DaypartingData } from "../types";

interface BulkDaypartingModalProps {
  advertisementIds: number[];
  categoryId?: number;
  startDate: Date;
  endDate: Date;
}

export const BulkDaypartingModal = NiceModal.create(
  ({ advertisementIds, categoryId, startDate, endDate }: BulkDaypartingModalProps) => {
    const { t } = useTranslation(["advertising", "common"]);
    const modal = useModal();
    const mutation = useBulkUpdateDayparting();
    const [data, setData] = useState<DaypartingData>({
      day_parting_method: 0,
      day_parting_multipliers: {},
    });

    const handleConfirm = () => {
      mutation.mutate(
        {
          advertisement_ids: advertisementIds,
          day_parting_method: data.day_parting_method,
          day_parting_multipliers: data.day_parting_multipliers,
        },
        {
          onSuccess: () => modal.remove(),
        },
      );
    };

    return (
      <Modal
        isOpen={modal.visible}
        isDismissable
        onOpenChange={(isOpen) => !isOpen && modal.remove()}
        title={t(($) => $.advertising["Update Dayparting"])}
        css={{ minWidth: "80vw" }}
      >
        <VStack gap="large" alignItems="stretch" paddingY="xlarge" paddingX="xlarge" overflow="auto">
          <DayPartingForm
            advertisements={advertisementIds}
            categoryId={categoryId}
            size="sm"
            initialValue={data}
            onChange={setData}
            startDate={startDate}
            endDate={endDate}
          />

          <p className={css({ textAlign: "center" })}>
            {t(($) => $.advertising["Are you sure you want to update the dayparting for the selected media plans?"], {
              count: advertisementIds.length,
            })}
          </p>

          <HStack justifyContent="space-around">
            <Button variant="secondary" onPress={() => modal.remove()}>
              {t(($) => $.common.actions.Cancel)}
            </Button>
            <Button onPress={handleConfirm} isPending={mutation.isPending}>
              {t(($) => $.advertising["Confirm"])}
            </Button>
          </HStack>
        </VStack>
      </Modal>
    );
  },
);
